import { useNavigate } from "react-router";
import { Assets } from "../../../assets";
import style from "./style.module.scss";

type GoBackType = {
  uri?: string;
};

export const GoBack = ({ uri }: GoBackType) => {
  const navigate = useNavigate();

  const onGoBack = () => {
    if (uri) {
      navigate(uri);
    } else {
      navigate(-1);
    }
  };

  return (
    <div className={style.wrapper} onClick={onGoBack}>
      <img src={Assets.iconsSvg.backArrow} className={style.image} />
    </div>
  );
};
